<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>网络创业实训平台</span>
        <b>NETWORK ENTREPRENEURSHIP TRAINING PLATFORM</b>
      </div>
      <div class="list">
        <ul>
          <li>互联网思维</li>
          <li>线上运维</li>
          <li>电商人才</li>
          <li>仿真实战</li>
        </ul>
        <p>
          《东云启创互联网创业教学平台》将实践教学与IT技术成功结合，打造了国内领先的系统化、集成化的互联网创业模拟实训系统，有针对性的解决了线上运营过程中的实训难题。整个平台围绕互联网时代特色，符合“专注、极致、口碑、快”的互联网思维，培养创业者具备互联网素质，成为新型综合互联网电商人才。
        </p>
      </div>
      <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>模拟商城</p>
            <div class="line"></div>
            <div class="text">
              模拟商城仿真知名电商平台，为学员营造一个逼真的店铺创办和经营管理的实操环境。模拟商城分为卖家中心和买家中心两大模块。卖家中心包括我要开店、店铺管理、宝贝管理、物流管理、交易管理、营销活动、客服服务、数据统计分析、个人中心九大部分。
            </div>
          </div>
          <div class="right">
            <img
            style="width:580px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Entrepreneurship training/img1.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:502px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Entrepreneurship training/img2.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>在线学习平台</p>
            <div class="line"></div>
            <div class="text">
             在线学习平台以慕课理念制作互联网创业培训系列精品课程，满足翻转课堂的教学需求。启创学院分为热门分类、课程中心、论坛讲堂、创业联盟、启创直播、创业大赛六大模块。包括农村电商、互联网思维、移动互联、电商技术、法律讲堂、沙龙分享、大咖直播、电商大赛等六大项二十八门类系列精品课程。
            </div>
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>培训管理</p>
            <div class="line"></div>
            <div class="text">
              培训管理实现信息化管理，并实现与培训指导中心创业培训工作管理部门实现互联互通、数据共享。培训管理分为管理员管理和教师管理两大角色。管理员管理包括教学管理、成绩管理、创业跟踪、学习资源、服务政策五大部分。
            </div>
          </div>
          <div class="right">
            <img
            style="width:381px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Entrepreneurship training/img3.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
            style="width:343px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Entrepreneurship training/img4.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>供销系统</p>
            <div class="line"></div>
            <div class="text">
             供销系统利用Internet技术及信息集成技术，将供应链管理、客户关系管理等功能全面集成优化，实现商品端的产品一键上架、订单抓取、库存同步及发货、退换货等功能，为暂时没有货源渠道的学员第一时间对接货源，解决学员创业初期组织货源困难以及资金风险等问题。
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'EntrepreneurshipTraining',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }

}
</script>

<style lang="scss" scoped>
.setion {
  margin: 0 auto;
  display: flex;
  width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;
  // background-color: rgb(35, 135, 228);

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    p {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .line {
      margin-top: 20px;
      width: 120px;
      height: 4px;
      background: #f39a21;
    }
    .text {
      width: 468px;
      margin-top: 60px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
       line-height: 1.8;
    }
  }
  .right {
    flex: 1;
  }
}
.bgbox {
  width: 100%;
}
.bgbox:nth-child(2n){
background: #f8f8f8;
.left {
  padding-left: 140px;
}
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
  .content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .headerbg {
      width: 100%;
      height: 580px;
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Entrepreneurship training/headerbg.png");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      span {
        font-size: 42px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      b {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #006cda;
      }
    }
    .list {
      width: 100%;
      height: 243px;
      background: #f8f8f8;
    }
    .list > ul {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      li {
        list-style: none;
        height: 43px;
        text-align: center;
        width: 300px;
        border-right: 1px solid #999999;
        line-height: 43px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      li:nth-child(4) {
        border-right: none;
      }
    }
    .list p {
      margin: 0 auto;
      text-align: center;
      width: 1067px;
      margin-top: 30px;
      line-height: 1.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Entrepreneurship-training.vue